<div class="flex flex-row justify-between h-12 common-bg ">

    <div class="grid grid-cols-12 pl-2 py-1 w-full items-center">
        <div class="col-span-6">
            <div class=" text-2xl  text-white" style="align-items: center;margin-left: 20px;">
                View Document
            </div>
        </div>
        <div class="col-span-2" style="    text-align: right;
        margin-top: 8px;
        margin-right: 14px;">
            <!-- <mat-icon class="icon-box" (click)="printPdf(docData.dcURL,$event)">print</mat-icon> -->

        </div>
        <div class="col-span-2" style="align-items: right;">
            <button mat-button (click)="downloadPDF(docData.dcURL)" style="    float: right;
            margin-top: 3px;
            background: #fbfbfb;">
                <mat-icon class="text-black">download</mat-icon> Download
            </button>
        </div>

        <div class="col-span-2" style="align-items: right;">
            <button mat-button (click)="cancleDcVwr()" style="    float: right;">
                <mat-icon class="text-white" [svgIcon]="'heroicons_solid:x'"></mat-icon>
            </button>
        </div>
    </div>

</div>
<div *ngIf="docData && docData.dcURL" id="outerContainer">
    <div >
        <div *ngIf="fileType == 'pdf'" class="pdf-container">
            <pdf-viewer [src]="docData.dcURL" style="height: 100vh;" [render-text]="true" [zoom-scale]="'page-fit'"
                [page]="1" [rotation]="0" [show-borders]="false" [stick-to-page]="true" [zoom]="1"
                [original-size]="true" [render-text-mode]="2" [show-all]="true" [fit-to-page]="true"
                [autoresize]="true"></pdf-viewer>
        </div>
        <div *ngIf="fileType == 'image'" class="img-container">
            <img [src]="docData.dcURL"  alt="">
        </div>
        <div *ngIf="fileType == 'NA'">
            <div class="text-center">Preview not available please download.</div>
        </div>
    </div>
</div>